import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Table } from 'react-bootstrap';
import { faList } from '@fortawesome/pro-solid-svg-icons';

import AddControl from 'components/add_control';
import Default from './default';
import EmptyState from 'bundles/settings/empty_state';
import Modal from './modal';
import { defaultCategoryName } from './utils';
import { saveDefaultDeduction } from './api';

import './styles.scss';

export default function DefaultDeductionSettings({ categories, defaultDeductions, features, options }) {
  if (!features.defaultDeductions) {
    return null;
  }

  const [defaults, setDefaults] = useState(defaultDeductions);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const categoryNames = [...categories.map(category => category.name), defaultCategoryName];

    const fixedDefaults = [];
    const updatedDefaults = defaults.map((defaultDeduction) => {
      if (!categoryNames.includes(defaultDeduction.category)) {
        defaultDeduction = { ...defaultDeduction, category: defaultCategoryName };
        fixedDefaults.push(defaultDeduction);
      }

      return defaultDeduction;
    });

    if (fixedDefaults.length > 0) {
      setDefaults(updatedDefaults);
      for (const fixedDefault of fixedDefaults) {
        saveDefaultDeduction(fixedDefault);
      }
    }
  }, [categories]);

  function addDefault(newDefault) {
    setDefaults([...defaults, newDefault]);
  }

  function updateDefault(updatedDefault) {
    setDefaults(defaults.map((defaultDeduction) => {
      return defaultDeduction.id === updatedDefault.id ? updatedDefault : defaultDeduction;
    }));
  }

  function removeDefault(deletedDefault) {
    setDefaults(defaults.filter(defaultDeduction => defaultDeduction.id !== deletedDefault.id));
  }


  return (
    <>
      <div className="row">
        <div className="col-xs-12 default-deduction-settings">
          <h3 className="mt-0">Default Deductions</h3>
          {defaults.length > 0 &&
            <div className="d-flex justify-content-end align-items-center mb-3">
              <AddControl className="ml-3" name="add-default-deduction" onClick={() => setShowModal(true)}>
                Add Default Deduction
              </AddControl>
            </div>
          }

          {defaults.length === 0 &&
            <EmptyState
              buttonText="Add Default Deduction"
              faIcon={faList}
              iconClassNames="h3 m-0 text-muted"
              message="No defaults have been added yet"
              onClick={() => setShowModal(true)}
            />
          }

          {defaults.length > 0 &&
            <div className="backoffice-settings-table-wrapper sticky-actions">
              <Table responsive>
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Description</th>
                    <th>Deduction Type</th>
                    {features.transactionSideDetails && <th>Transaction Side</th>}
                    <th>Rules</th>
                    <th>Amount</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {defaults.map(defaultDeduction => (
                    <Default
                      categories={categories}
                      defaultDeduction={defaultDeduction}
                      features={features}
                      key={defaultDeduction.id}
                      options={options}
                      onChange={updateDefault}
                      onDelete={removeDefault}
                    />
                  ))}
                </tbody>
              </Table>
            </div>
          }
        </div>
      </div>

      <Modal
        categories={categories}
        features={features}
        options={options}
        show={showModal}
        onHide={() => setShowModal(false)}
        onSave={addDefault}
      />
    </>
  );
}

DefaultDeductionSettings.propTypes = {
  categories: PropTypes.array,
  defaultDeductions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })).isRequired,
  features: PropTypes.shape({
    defaultDeductions: PropTypes.bool,
    transactionSideDetails: PropTypes.bool,
  }).isRequired,
  options: PropTypes.object,
};
